import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean | undefined> = (isError) => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: isError
    ? (p) => p.palette.error[300]
    : (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(1),
  px: 1,
  py: 0.75,
});

export const colorBox: SxStyleFunc<string> = (hexCode) => ({
  width: (p) => p.spacing(4),
  height: (p) => p.spacing(4),
  borderRadius: (p) => p.spacing(1),
  background: hexCode,
});

export const errorIcon: SxStyle = {
  color: (p) => p.palette.error[500],
};

export const endIcon: SxStyle = {};

export const startIcon: SxStyle = {
  color: (p) => p.palette.grey[500],
};

export const errorMessage: SxStyle = {
  color: (p) => p.palette.error[500],
  fontSize: (p) => p.typography.body2,
};

export const label: SxStyle = {
  fontSize: (p) => p.typography.body2,
};

export const fileName: SxStyle = {
  flex: 1,
  fontSize: (p) => p.typography.caption,
  height: (p) => p.spacing(4),
};

export const fileBtn: SxStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
};
